import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import SmoothScroll from "./components/SmoothScroll";
import ParticleBackground from "./components/ParticleBackground";
import Header from "./components/Header";
import HeroSection from "./components/HeroSection";
import LatestTweet from "./components/LatestTweet";
import ThesisSection from "./components/ThesisSection";
import LeadershipSection from "./components/LeadershipSection";
import PortfolioSection from "./components/PortfolioSection";
import ContactSection from "./components/ContactSection";
import Footer from "./components/Footer";
import AuthCallback from "./components/AuthCallback";
import SentinelDashboard from "./components/SentinelDashboard";
import SentinelLogin from "./components/SentinelLogin";
import { initAnalytics } from "./utils/analytics";

// Landing Page Component
const LandingPage = () => {
  // Initialize analytics on mount
  useEffect(() => {
    initAnalytics();
  }, []);

  return (
    <SmoothScroll>
      <div className="relative min-h-screen bg-[#050505] overflow-x-hidden">
        {/* Neural Mesh Background */}
        <div className="fixed inset-0 z-0">
          <ParticleBackground />
          {/* Gradient overlays for depth */}
          <div className="absolute inset-0 bg-gradient-to-b from-[#0A0F1C]/50 via-transparent to-[#050505]" />
        </div>

        {/* Content */}
        <div className="relative z-10">
          <Header />
          <main>
            <HeroSection />
            <LatestTweet />
            <ThesisSection />
            <LeadershipSection />
            <PortfolioSection />
            <ContactSection />
          </main>
          <Footer />
        </div>
      </div>
    </SmoothScroll>
  );
};

// App Router Component
function AppRouter() {
  const location = useLocation();

  // Check URL fragment for session_id (handles OAuth callback)
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }

  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/sentinel" element={<SentinelDashboard />} />
      <Route path="/sentinel/twitter-callback" element={<SentinelDashboard />} />
      <Route path="/sentinel/login" element={<SentinelLogin />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
